import axios from 'axios';
import {
  SERVER_ERROR_KEY,
  handleAxiosResponse,
  handleError,
} from '@r-and-a-shared-ui/utils';

import httpErrors, { HttpError } from 'http-errors';
import { TokenExchangeInput } from '../user-auth-api-input-schema';

export const tokenExchangeQuery = async ({
  input,
}: {
  input: TokenExchangeInput;
}) => {
  try {
    const { url, xApiKey, realm, idToken, accessToken, refreshToken } =
      input;

    const data = {
      grant_type: 'urn:ietf:params:oauth:grant-type:token-exchange',
      subject_token_type: 'idAccessRefresh',
      subject_token: JSON.stringify({
        idToken: idToken,
        accessToken: accessToken,
        refreshToken: refreshToken,
      }),
    };

    const result = await axios
      .post(`${url}/api/v2/openid/aws_cognito_randa_sso/exchange`, data, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          Accept: 'application/json',
          'x-api-key': xApiKey,
          Realm: realm,
        },
      })
      .then(handleAxiosResponse)
      .catch(handleError);

    if (result.hasErrors) {
      const err = httpErrors?.[result?.statusCode as keyof typeof httpErrors]?.(
        result?.errorMessages?.join('\n'),
      ) as HttpError;
      console.log('result - exchange token has errors', result);
      err.name = result.data?.value?.errorKey || SERVER_ERROR_KEY;
      throw err;
    }

    return result.data.access_token;

  } catch (err: any) {
    console.error(`Error on Token Exchange: ${err?.message || err}`);
    err.message = JSON.stringify(err?.name, err?.message);
    throw err;
  }
};
